<script lang="ts">
import {$inj, $injByInterface} from '@/common/decorators/depinject'
import WorkflowFactory from '@/common/services/Workflow/WorkFlowFactory'
import type IWorkspaceStore from '@/common/services/Workspace/IWorkspaceStore'
import {defineComponent} from 'vue'
import {VsgProgress} from '@jack-henry/jha-vue-components'

export default defineComponent({
  name: 'bltPreloader',
  components: {VsgProgress},
  setup() {
    const workspaceStore = $injByInterface<IWorkspaceStore>('IWorkspaceStore')
    const workflowFactory = $inj(WorkflowFactory)
    return {
      workspaceStore,
      workflowFactory
    }
  }
})
</script>

<template>
  <div class="loading">
    <vsg-progress
      card
      type="circular"
      size="large"
      indeterminate></vsg-progress>
  </div>
</template>
